module.exports = __webpack_public_path__ + "img/x_pattern.b49c97c4.png";